import { useState } from "react"
import { observer } from "mobx-react"
import {
  Button,
  DatePicker,
  Flex,
  Form,
  Modal,
  Radio,
  Select,
  Typography,
} from "antd"

import { ReportCreateTypeEnum } from "@src/shared/api/generated"
import css from "./index.module.css"
import { ReportsStore } from "./store"

type Props = {
  isOpen: boolean
  onCancel: () => void
}
const { Item } = Form

const { Paragraph, Title } = Typography

const { RangePicker } = DatePicker

const defaultReportType = ReportCreateTypeEnum.Transactions

export const ModalReports = observer(({ isOpen, onCancel }: Props) => {
  const [store] = useState(new ReportsStore())
  const [reportType, setReportType] =
    useState<ReportCreateTypeEnum>(defaultReportType)

  const { addDate, addProject, isLoading, projects, sendReportRequest } = store
  const [form] = Form.useForm()
  const onProjectChange = (value: string) => {
    addProject(value)
  }

  const onDateChange = (_: any, dateString: string[]) => {
    const [from, to] = dateString

    const dateFrom = from === "" ? "" : new Date(from as string).toISOString()

    const dateTo = to === "" ? "" : new Date(to as string).toISOString()

    addDate(dateFrom, dateTo)
  }

  const onSubmit = async () => {
    await sendReportRequest(reportType).finally(() => {
      onClose()
    })
  }

  const onClose = () => {
    onCancel()

    addProject(undefined)

    addDate("", "")

    setReportType(defaultReportType)

    form.resetFields()
  }

  const isBalancesReport = reportType === ReportCreateTypeEnum.Balance

  return (
    <Modal destroyOnClose footer={null} onCancel={onClose} open={isOpen}>
      <div className={css.modalWrapper}>
        <div className={css.textWrapper}>
          <Title level={4} style={{ margin: 0 }}>
            Generate report{" "}
          </Title>
          <Paragraph className={css.paragraph} style={{ margin: 0 }}>
            A link to the generated report will be sent to the e-mail address
            you provided during registration
          </Paragraph>
        </div>
        <Form
          className={css.form}
          form={form}
          id="GENERATED_ID_MODALREPORTS_FORM_VOID_1"
          layout="vertical"
          name="reports"
          onFinish={onSubmit}
          size="large"
        >
          <Flex gap={16} vertical>
            <Item label="Report type">
              <Radio.Group
                buttonStyle="solid"
                onChange={(e) => setReportType(e.target.value)}
                optionType="button"
                options={[
                  {
                    label: "Transactions",
                    value: ReportCreateTypeEnum.Transactions,
                  },
                  { label: "Balances", value: ReportCreateTypeEnum.Balance },
                ]}
                value={reportType}
              />
            </Item>
            {!isBalancesReport && (
              <>
                <Item label="Project Name" name="project_id">
                  <Select
                    loading={isLoading}
                    onChange={onProjectChange}
                    options={projects}
                  />
                </Item>
                <Item label="Choose period" name="date">
                  <RangePicker
                    onChange={onDateChange}
                    style={{ width: "100%" }}
                  />
                </Item>
              </>
            )}
          </Flex>
          <div className={css.buttonsWrapper}>
            <Button
              htmlType="button"
              id="GENERATED_ID_MODALREPORTS_BUTTON_CANCEL_1"
              onClick={onClose}
              size="large"
              type="default"
            >
              Cancel
            </Button>
            <Button
              disabled={false}
              htmlType="submit"
              id="GENERATED_ID_MODALREPORTS_BUTTON_GENERATE_1"
              loading={isLoading}
              size="large"
              type="primary"
            >
              Generate
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  )
})
